import React, { useState, useEffect } from 'react';
import '../assets/audioplayer.css'; // Importa el archivo CSS con los estilos personalizados
import secureLocalStorage from 'react-secure-storage';
import { styles } from '../assets/styles';
import { CluesPokemon } from './clues';
import { getPokemonFromStorageCries } from '../services/getPokemonFromStorage';

function AudioPlayer() {
  const [audioUrl, setAudioUrl] = useState(null);
  const fetchCountCries = parseInt(localStorage.getItem('fetch_count_cries')) || 0;

  const pokemonCry = secureLocalStorage.getItem('audio_url');

  const randomPokemon = getPokemonFromStorageCries();

  useEffect(() => {
    setAudioUrl(pokemonCry);
  }, [pokemonCry]);

  if (!audioUrl) {
    return (
      <div style={styles.loading}>
        <div style={styles.loadingText}>Loading POKéMON info...</div>
        <div className="circle" style={styles.loadingCircle} />
      </div>
    );
  }

  return (
    <div style={styles.pokeBoxAudio1}>
      <div style={styles.pokeBoxAudio2}>
        <div style={styles.pokeBoxAudio3}>
          <div style={styles.pokeBoxAudio4}>
            <audio
              controls
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
              className="audio-player"
            >
              <source src={audioUrl} type="audio/ogg" />
              Your browser does not support the audio element.
            </audio>
            <CluesPokemon randomPokemon={randomPokemon} fetchCountCries={fetchCountCries} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AudioPlayer;
